import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LayoutService {
  private layoutSubject = new BehaviorSubject<string>('HORIZONTAL');
  private mocDataSubject = new BehaviorSubject<boolean>(false);
  private chartType = new BehaviorSubject<string>('PIE');
  private sidenavPersistent = true;

  layout$ = this.layoutSubject.asObservable();
  mocData$ = this.mocDataSubject.asObservable();

  setLayout(layout: string) {
    this.layoutSubject.next(layout);
  }

  getCurrentLayout() {
    return this.layoutSubject.value;
  }

  setMocData(value: boolean) {
    this.mocDataSubject.next(value);
  }

  getCurrentMocData(): boolean {
    return this.mocDataSubject.value;
  }

  setChartType(chartType: string) {
    this.chartType.next(chartType);
  }

  setSidenavPersistence(persistent: boolean) {
    this.sidenavPersistent = persistent;
  }

  isSidenavPersistent(): boolean {
    return this.sidenavPersistent;
  }
}